let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4zgGL")).then(() => parcelRequire('2qERs'));